import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { customerResource } from './../../system/customerManage/request';
import { customerInsuranceList, customerInsuranceStatus } from './request';
import { applicationResource } from './../../customer/applicationManage/request';
import codeModel from './codeModel.vue';
import { COLUMNS } from './utils';
export default {
  components: {
    codeModel
  },
  data() {
    return {
      form: {
        applicationId: undefined
      },
      dateArr: [],
      customer: [],
      COLUMNS,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      applicationList: [],
      license: [],
      showItem: false,
      codeShow: false
    };
  },
  created() {
    customerResource({}).then(res => {
      this.customer = res;
    });
    this.customerChange();
    this.getDataFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      customerInsuranceList(obj).then(res => {
        this.pagination.total = res.totalNum;
        this.data = res.items;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    agencyChange(val) {
      let arr = this.intermediaryList.filter(item => item.id == val);
      this.form.unitId = arr.length != 0 ? arr[0].unitId : undefined;
    },
    customerChange() {
      this.form.applicationId = undefined;
      applicationResource({
        customerId: this.form.customerId,
        isAll: true
      }).then(res => {
        this.applicationList = res;
      });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    checkedFun(val) {
      if (!this.isAuth('home.customerInsuranceStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      customerInsuranceStatus({
        customerInsuranceId: val.customerInsuranceId,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('操作成功') + '!');
        val.status = val.status == 1 ? 0 : 1;
      });
    },
    handleCode() {
      this.codeShow = true;
      this.$nextTick(() => {
        this.$refs.codeRef.init();
      });
    },
    onChange(date) {
      if (date.length != 0) {
        this.form.startAt = date[0];
        this.form.endAt = date[1];
      } else {
        this.form.startAt = '';
        this.form.endAt = '';
      }
    }
  }
};